import { http, HttpResponse } from 'msw';

import { v4CreditAccountMock1 } from '../data/creditAccounts';
import { v4CreditCard1Mock } from '../data/creditCards';
import { kredittbankenReservationsMock1 } from '../data/kbReservations';
import { kredittbankenTransactionsMock1 } from '../data/kbTransactions';
import { v4Resource } from '../helpers';

export const v4KredittbankenHandlers = [
    http.get(v4Resource('/credit-card-accounts'), async () => {
        return HttpResponse.json([v4CreditAccountMock1]);
    }),

    http.get(v4Resource('/credit-card-accounts/:accountId'), async ({ params }) => {
        if (params.accountId) {
            if (v4CreditAccountMock1.accountId === params.accountId) {
                return HttpResponse.json(v4CreditAccountMock1);
            }
        }
        return HttpResponse.error();
    }),

    http.get(v4Resource('/credit-card-accounts/:accountId/transactions'), async ({ params }) => {
        if (params.accountId) {
            if (v4CreditAccountMock1.accountId === params.accountId) {
                return HttpResponse.json(kredittbankenTransactionsMock1);
            }
        }
        return HttpResponse.error();
    }),

    http.get(v4Resource('/credit-card-accounts/:accountId/reservations'), async ({ params }) => {
        if (params.accountId) {
            if (v4CreditAccountMock1.accountId === params.accountId) {
                return HttpResponse.json(kredittbankenReservationsMock1);
            }
        }
        return HttpResponse.error();
    }),

    http.get(v4Resource('/credit-cards'), async () => {
        return HttpResponse.json([v4CreditCard1Mock]);
    }),

    http.get(v4Resource('/credit-cards/:id'), async ({ params }) => {
        if (params.id && params.id === v4CreditCard1Mock.id) {
            return HttpResponse.json(v4CreditCard1Mock);
        }
        return HttpResponse.error();
    }),
];
